import React from 'react';
import PropTypes from 'prop-types';

import { Spacer, Text } from '@zillow/constellation';
import { Row, Col, Center } from '@zillow/zrs-comet';

import ContactMethodDetail from 'app/shared/components/WizardListingClaim/ContactMethodDetail';
import ListingClaimUtils from 'app/shared/utils/listingClaimUtils';

const { getContactType } = ListingClaimUtils;

const propTypes = {
    contactMethods: PropTypes.array.isRequired,
};

const RemovableContactsList = ({ contactMethods, incrementStep, onContactMethodSelection }) => {
    const handleDelete = (contactMethodToDelete) => {
        onContactMethodSelection({ value: contactMethodToDelete.value, type: getContactType(contactMethodToDelete) });
        incrementStep();
    };

    return (
        <div className="RemovableContactsList">
            <Row>
                <Col xs={0} md={2} />
                <Col xs={12} md={8}>
                    <Spacer marginBottom="lg">
                        <Center>
                            <Text>
                                Removing an unverified contact method will also
                                remove any listings associated with that contact
                            </Text>
                        </Center>
                    </Spacer>
                    {contactMethods.map((contactMethod, i) => (
                        <ContactMethodDetail
                            key={`removable-contact-${i}`}
                            type={getContactType(contactMethod)}
                            data={contactMethod}
                            onDelete={handleDelete}
                            inManageContactModal={true}
                        />
                    ))}
                </Col>
                <Col xs={0} md={2} />
            </Row>
        </div>
    );
};

RemovableContactsList.propTypes = propTypes;

export default RemovableContactsList;
